// ─── SOFT-LAUNCH TOGGLE ────────────────────────────────────────────────
// Single source of truth, shared by App.js (blocks Checkout) and
// Home.jsx (shows the "Coming Soon" banner). Flip to false when ready
// to go fully live — no other code changes needed anywhere.
export const COMING_SOON_MODE = true
